module.exports = __webpack_public_path__ + "img/1.58a16f0a.jpg";